import './new-tier-level.scss';

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormTierLevel from "../form-tier-level/form-tier-level";
import { useNewTierLevel } from './new-tier-level.hook';

export function NewTierLevel() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewTierLevel();

  return (
    <div id="NewTierLevel" className="tier-level">
      <HeaderContent
        title={<h1>New Tier Level</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormTierLevel />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewTierLevel;